import { Mood } from "generator/components/mood";
import type { RuntimeTheme } from "./theme";

export function moodColors(theme: RuntimeTheme): Record<Mood, string> {
    return {
        [Mood.Default]: theme.primaryAccentColor,
        [Mood.Neutral]: "#797989",
        [Mood.Warning]: "#EC9D00",
        [Mood.Danger]: theme.destroyColor,
        [Mood.Success]: "#00CB69",
    };
}
